import { css, cx } from "@emotion/css";
import { iconStyles } from "@octopusdeploy/design-system-components/src/components/Icon/iconStyles";
export const k8sIconStyles = cx(iconStyles, css({
    width: 20,
    height: 20,
}));
